import script from "./company-tag.vue?vue&type=script&setup=true&lang=js"
export * from "./company-tag.vue?vue&type=script&setup=true&lang=js"

import "./company-tag.vue?vue&type=style&index=0&id=64185b00&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64185b00"]])

export default __exports__